<template>
    <div v-if="result !== undefined" v-bind:class="['result',{'expanded':expanded}, {'even':(order === 'even')}]">
        <div class="headline">
            <div class="result-first">
                <a v-if="(result.status === 'parsed' || result.status === 'redirected' || result.status === 'error')" v-bind:class="{'rotated': expanded}" v-on:click="expanded = !expanded"  href="#"><chevron-right-icon></chevron-right-icon></a>
                <clock-icon v-else></clock-icon>
                <a v-bind:class="['refresh',{'rotating':(result.status === 'new' || result.status === 'parsing')}]" class="refresh" href="#" v-on:click="resultRestart"><refresh-cw-icon></refresh-cw-icon></a>
            </div>
            <add-note-link v-bind:text-to-add="result.URL"></add-note-link>
            <div class="result-last" v-if="result.status !== 'parsing' && !expanded && children.length !== 0">
                <span v-for="child in children" v-bind:key="child.id" class="http-code-small" v-bind:class="['htt-code-small', codeClass(child.http_status)]">
                    {{child.http_status}}
                    <span v-if="child.http_status*1 >= 300 && child.http_status*1 < 400 " v-bind:class="['tooltiptext', codeClass(child.http_status)]">:&nbsp;<a target="_blank" v-bind:href="child.redirect_URL">{{tooltipText(child)}}</a></span>
                </span>
            </div>
            <div class="result-last" v-else-if="children.length === 0">
                <span class="http-code-small gray">
                    parsing...
                </span>
            </div>
            <div class="result-stretch"><a v-bind:href="result.URL" target="_blank">{{result.URL}}</a> <span class="loves" title="links to us" v-if="result.loves_us === 'YES'">&#9829;</span> <span class="redirects" title="redirects to us" v-if="result.redirects_to_us === 'YES'">&#9733;</span></div>
        </div>
        <template v-if="expanded && (children.length > 0)">
            <template v-for="(item, index) in children">
                <div class="slidedown" v-bind:key="item.id">
                    <a v-bind:class="{'rotated':(item.expanded & true)}" href="#" v-on:click="item.expanded = ! (item.expanded & true)"><chevron-right-icon></chevron-right-icon></a>
                    <span v-bind:class="['http-code', 'zero', codeClass(item.http_status)]">
                        {{item.http_status}}
                        <span v-if="item.http_status*1 >= 300 && item.http_status*1 < 400 " v-bind:class="['tooltiptext', codeClass(item.http_status)]">:&nbsp;<a target="_blank" v-bind:href="item.redirect_URL">{{tooltipText(item)}}</a></span>
                    </span>
                    <a target="_blank" v-bind:href="item.URL">{{item.URL}}</a> <span class="loves" title="links to us" v-if="item.loves_us === 'YES'">&#9829;</span> <span class="redirects" title="redirects to us" v-if="item.redirects_to_us === 'YES'">&#9733;</span>
                </div>
                <u-r-l-result-body v-if="item.expanded === true && expanded" v-bind:id="item.id" v-bind:color-class="codeClass(item.http_status)"></u-r-l-result-body>
            </template>
        </template>
    </div>
</template>

<script>
    import axios from 'axios'
    import config from '@/config'

    import CopyLink from "@/components/UI/_base-UI-CopyLink"
    import AddNoteLink from '@/components/small/AddNoteLink'
    import URLResultBody from "@/components/small/URLResultBody"

    import Socket from "@/IOSocket"

    import { ChevronRightIcon, ExternalLinkIcon, ClockIcon, RefreshCwIcon } from 'vue-feather-icons'

    import CustomEvents from '@/CustomEvents'

    export default {
        name: "URLResult",
        components:{
            CopyLink,
            URLResultBody,
            AddNoteLink,
            ChevronRightIcon,
            ExternalLinkIcon,
            ClockIcon,
            RefreshCwIcon,
            CustomEvents,
        },

        data: function () {
            return {
                children: [],
                expanded: false
            }
        },
        created: function () {
            Socket.$on("message", this.wsReceived)
        },
        beforeDestroy(){
            Socket.$off("message", this.wsReceived)
        },
        props: {
            result: Object,
            selected: Boolean,
            order: String
        },
        watch: {
            result: {
                handler: function () {
                    this.getChildren();
                },
                immediate: true
            }
        },
        methods: {
            resultRestart: function (){
                this.children = [];
                this.expanded = false;

                CustomEvents.$emit('result-restart', this.result)
            },
            wsReceived:function (msg) {
                if (msg.service === 'urlschecker') {
                    switch (msg.action) {
                        case 'new':{

                        }break;
                        case 'deleted':{

                        }break;
                        case 'child-updated':{
                            if (msg.data === this.result_id) {
                                this.resultRestart()
                                //this.getChildren()
                            }
                        }break;

                    }
                }
            },
            getChildren: function (){
                this.working++;

                axios
                    .get(config.api_url + '/?op=urlresults&cmd=children&id='+this.result.id)
                    .then(response => {
                        if (response.data.length == 1){
                            response.data[0].expanded = true;
                        }
                        this.children = response.data;
                        this.working--;
                    })
                    .finally(() => {})
            },
            tooltipText: function (child){
                let http_code = child.http_status*1;

                if (http_code >= 200 && http_code < 300){
                    return 'OK!';
                }
                if (http_code >= 300 && http_code < 400){
                    return child.redirect_URL;
                }
                if (http_code >= 400 && http_code < 500){
                    return 'NOT\xA0FOUND!';
                }
                if (http_code >= 500 && http_code < 600){
                    return 'SERVER\xA0ERROR!';
                }
                if (http_code === 666){
                    return 'GENERAL\xA0ERROR';
                }
            },
            codeClass: function (code) {
                code = code*1;
                if (code >= 200 && code < 300){
                    return 'green';
                }
                if (code >= 300 && code < 400){
                    return 'blue';
                }
                if (code >= 400 && code < 500){
                    return 'yellow';
                }
                if (code >= 500 && code < 600){
                    return 'red';
                }
                if (code === 666){
                    return'red';
                }

                return 'gray';
            }
        }
    }
</script>
<style scoped>
    .loves{
        color: #ff028f;
    }

    .redirects{
        color: #ffaf03;
    }

    .expanded, .headline{
        padding: 0.5rem 0;
    }

    .result{
        vertical-align: middle;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #dfdfdf;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
        padding: 0 0.5rem 0 0.5rem;
    }

    .headline{
        height: 2rem;
    }

    .result-first{
        width: min-content;
    }

    .result-last{
        min-width: 8rem;
    }

    .result-stretch{
        flex: 1;
        overflow: hidden;
    }

    .result.expanded{
        padding: 0 0.5rem 0.5rem 0.5rem;
    }

    .result.even {
        background: #eeeeee;
    }

    .result p, .result div{
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin: 0;
        text-shadow: 1px 1px 0px #ffffff;
    }

    .result a{
        text-decoration: underline;
        margin: 0.2rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .result svg{
        text-decoration: underline;
        width: 1.1rem;
        margin: 0.2rem;
    }

    .result a svg{
        margin: 0;
    }

    .result p>svg{
        color: #a9a9a9;
        width: 1.1rem;
        margin: 0.2rem;
    }

    .http-code, .http-code-small{
        border-right: 1px solid #EEEEEE;
        border-top: 1px solid #ffffff;
        border-left: 1px solid #6c6c6c;
        border-bottom: 1px solid #585858;
        font-family: monospace;
        color: #ffffff;
        font-weight: bold;
        border-radius: 0.5rem;
        padding: 0.5rem;
        text-shadow: 1px 1px 0px #585858;
        box-shadow: -1px 1px 0px 1px rgba(6, 6, 6, 0.18)
    }

    .http-code, .http-code-small{
        font-size: 1.2rem;
        display: flex;
        align-items: baseline;
        margin: 0 0.2rem;
        background-color: #7f7f7f;
    }

    .tooltiptext a{
        color: #ffffff;
        margin: 0;
        padding: 0;
        font-family: monospace;
        display: inline;
    }

    .tooltiptext {
        visibility: hidden;
        font-family: monospace;
        display: inline-block;
        text-align: center;
        width: 0;
        max-width: 0;
        overflow: hidden;
        margin: 0;
        vertical-align: middle;
    }

    .http-code:hover .tooltiptext,  .http-code-small:hover .tooltiptext, .tooltiptext:hover {
        width: max-content;
        visibility: visible;
        max-width: 1000px;
    }

    .http-code .tooltiptext{

    }

    .http-code-small{
        font-size: 0.9rem;
    }

    .misc{
        font-size: 0.8rem;
        font-style: italic;
        color: #5a5a5a;
    }

    .http-headers, .http-request{
        border-right: 1px solid #EEEEEE;
        border-top: 1px solid #ffffff;
        border-left: 1px solid #6c6c6c;
        border-bottom: 1px solid #585858;
        font-family: monospace;
        color: #ffffff;
        font-weight: bold;
        background-color: #000000;;
        border-radius: 0.5rem;
        padding: 0.5rem;
        font-size: 1.2rem;
        margin: 0.2rem;
        text-shadow: 1px 1px 0px #585858;
    }

    .http-request svg{
        width: 1.2rem;
        height: 1.2rem;
    }

    svg.small{
        width: 0.9rem;
        height: 0.9rem;
    }

    .red{
        background-color: #e2001d;
    }

    .blue{
        background-color: #42b4dc;
    }

    .green{
        background-color: #3ed086;
    }

    .yellow{
        background-color: #ffc533;
    }

    .gray{
        background-color: #ababab;
    }

    .rotated {
        animation: deg90 300ms ease 0s 1;
        animation-fill-mode: forwards;
    }

    .slideup, .slidedown {
        max-height: 0;
        overflow-y: hidden;
        align-items: start;
        background-color: #ffeca6;
    }

    div.slideup{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }

    div.slidedown {
        padding: 0.5rem 0;
        max-height: 100px;
        border-left: 1px solid #ffffff;
        border-right: 1px solid #ababab;
        border-top: 1px solid #fff;
        border-bottom: 1px solid #888;
    }

    div.slidedown:first-of-type{
        border-top: 1px solid #888;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
    }

    div.slidedown:last-of-type{
        border-bottom: 1px solid #ffffff;
        border-bottom-left-radius: 0.3rem;
        border-bottom-right-radius: 0.3rem;
    }
</style>
